const FooterCopy = {

    SR: 'Sport Relief is an initiative of Comic Relief. Comic Relief is the trading name of Charity Projects, ' +
    'a registered charity in England and Wales (326568) and Scotland (SC039730), which is a company limited by' +
        'guarantee registered in England and Wales (01806414). Registered address: 6th Floor, The White Chapel Building, 10 Whitechapel High Street, London, E1 8QS.',
  
    CR: 'Comic Relief is the trading name of Charity Projects, a registered charity in England and Wales ' +
    '(326568) and Scotland (SC039730), which is a company limited by guarantee registered in England and Wales ' +
    '(01806414). Registered address: 6th Floor, The White Chapel Building, 10 Whitechapel High Street, London, E1 8QS.',
  
    BIGNIGHTIN: 'Big Night In is a joint initiative between BBC Children in Need and Comic Relief. ' +
    'This website and donation page is managed by Comic Relief for The Big Night In. ' +
    'BBC CHILDREN IN NEED incorporated and registered in England and Wales with Company number ' +
    '04723022 and Registered charity no. 802052 in England and Wales and SC039557 in Scotland whose ' +
    'registered office is at Bridge House, Media City UK, Salford, England, M50 2BH. ' +
    'Comic Relief is the trading name of Charity Projects, a registered charity in England and ' +
    'Wales (326568) and Scotland (SC039730), which is a company limited by guarantee registered in England and Wales (01806414). ' +
    'Registered address: 6th Floor, The White Chapel Building, 10 Whitechapel High Street, London, E1 8QS.',
  };
  
  export default FooterCopy;
